import React from 'react';

export default function SearchBar({ value, onChange, onClear }) {
  return (
    <div className="search-bar">
      <span className="search-icon">🔍</span>
      <input
        type="search"
        inputMode="search"
        autoComplete="off"
        placeholder="Buscar por código o nombre..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      {value ? (
        <button type="button" className="search-clear" onClick={onClear} aria-label="Limpiar">
          ✕
        </button>
      ) : null}
    </div>
  );
}
